var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breadcrumb.list),function(items,index){return _c('el-breadcrumb-item',{key:index},[_c('span',[_vm._v(_vm._s(items.name))])])}),1),_c('h1',[_vm._v(_vm._s(_vm.breadcrumb.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }